import { investmentFundsActions } from "app/features/investmentFunds/investmentFundsSlice";
import { useDispatch, useSelector } from "app/hooks";
import {
  getCustomStartDateBounds,
  getLimitingFund,
  isCustomStartDateValid,
} from "helpers/reportingPeriod";
import { useEffect } from "react";
import { logAnalyticsEvent } from "services/analytics";

export const CUSTOM_PERIOD_VALUE = "custom";

export const useReportingPeriod = () => {
  const dispatch = useDispatch();
  const { selectedFunds, reportingPeriod, isCustomPeriod, customStartDate } =
    useSelector((state) => state.investmentFunds);

  const limitingFund = getLimitingFund(selectedFunds);
  const maximumReportingPeriod = limitingFund
    ? limitingFund.availableReportingPeriod
    : 0;

  const { minStartDate, maxStartDate, endDate } =
    getCustomStartDateBounds(selectedFunds);
  const customStartDateValid = isCustomStartDateValid(
    customStartDate,
    minStartDate,
    maxStartDate,
  );

  useEffect(() => {
    if (!reportingPeriod && !isCustomPeriod) {
      dispatch(
        investmentFundsActions.updateReportingPeriod(maximumReportingPeriod),
      );
    }
  }, [reportingPeriod, isCustomPeriod, maximumReportingPeriod, dispatch]);

  const handleReportingPeriodChange = (years: number) => {
    logAnalyticsEvent({
      category: "Report details",
      action: "Page 2",
      label: `Reporting period - ${years}`,
    });
    dispatch(investmentFundsActions.updateReportingPeriod(years));
  };

  const handleSelectCustomPeriod = () => {
    logAnalyticsEvent({
      category: "Report details",
      action: "Page 2",
      label: "Reporting period - custom start date",
    });
    dispatch(investmentFundsActions.selectCustomPeriod());
    dispatch(investmentFundsActions.updateCustomStartDate(maxStartDate));
  };

  const handleCustomStartDateChange = (date: string) => {
    logAnalyticsEvent({
      category: "Report details",
      action: "Page 2",
      label: `Custom start date - ${date}`,
    });
    dispatch(investmentFundsActions.updateCustomStartDate(date));
  };

  const handleTooltip = () => {
    logAnalyticsEvent({
      category: "Report details",
      action: "Page 2",
      label: "Select the reporting period below tooltip",
    });
  };

  return {
    selectedFunds,
    maximumReportingPeriod,
    reportingPeriod,
    isCustomPeriod,
    customStartDate,
    customStartDateValid,
    minStartDate,
    maxStartDate,
    endDate,
    handleReportingPeriodChange,
    handleSelectCustomPeriod,
    handleCustomStartDateChange,
    handleTooltip,
  };
};
